// Guards against a stale GET response clobbering more-authoritative Bunkering ROB/Loss data.
//
// Two independent code paths write fuelRobData/bunkerLossData into BunkerContext:
// 1. Page-level reconciliation GETs (BunkeringPage.tsx/AolMain.tsx via
//    useGetBunkeringData.getFuelRobData/getBunkerLossData), which can be issued right around a
//    reconnect - i.e. before an offline sync has actually replayed a queued change to the
//    server - and therefore resolve with data that predates the user's own pending edit.
// 2. The offline-sync engine's post-sync "refresh_containing" push
//    (useBunkerRefreshResponseHandler), which reflects genuinely authoritative, freshly
//    confirmed server state fetched *after* the sync replay succeeded.
//
// Because these resolve asynchronously with no fixed ordering (especially once (1) is forced to
// hit the network rather than a fast local cache - see forceRefreshCache usage), an older
// (1)-type response can otherwise arrive AFTER a newer (2)-type response and silently overwrite
// it with stale data, requiring a manual page refresh to recover. This module lets (1)-type
// responses be discarded if a (2)-type response has already been applied more recently than the
// (1)-type request was issued - i.e. the (1)-type response cannot possibly reflect anything newer
// than what's already authoritatively on screen.
let lastAuthoritativeFuelRobAt = 0;
let lastAuthoritativeBunkerLossAt = 0;

export const markAuthoritativeFuelRobApplied = (): void => {
    lastAuthoritativeFuelRobAt = Date.now();
};

export const isFuelRobResponseStillValid = (issuedAt: number | undefined | null): boolean =>
    (issuedAt ?? 0) >= lastAuthoritativeFuelRobAt;

export const markAuthoritativeBunkerLossApplied = (): void => {
    lastAuthoritativeBunkerLossAt = Date.now();
};

export const isBunkerLossResponseStillValid = (issuedAt: number | undefined | null): boolean =>
    (issuedAt ?? 0) >= lastAuthoritativeBunkerLossAt;
